import { Box, Paper, Stack, Divider } from '@mui/material';
import { useEffect, useState} from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from "react-use";
import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { 
  fetchGetParticipantesCDEEE,
  fetchSaveGanadorParticipante,
  fetchUpdateList,
  selectListParticipantesCDEEE,
  selectUpdateList
} from '../../../redux/Sorteo/SorteoSlice';

import fondoImagenInicial from '../../../assets/Imagen-Concurso-Actualizado.png';  

const INTERVAL = 50;

const NamePicker = ({ participantes, interval, setGanadorSeleccionado, ganadorSeleccionado, imageValidate, setImageValidate }) => {
  const [empleado, setName] = useState(participantes.length > 0 ? participantes[0] : []);
  const [isWinner, setIsWinner] = useState(false);
  const [isRendering, setIsRendering] = useState(false);

  const { width, height } = useWindowSize();

  useEffect(() => {
    let intervalId;

    if (isRendering) {
      setIsWinner(false);
      intervalId = setInterval(() => {
        setName(participantes[Math.floor(Math.random() * participantes.length)]);
      }, interval);

      setTimeout(() => {
        setIsWinner(true);
        setIsRendering(false);
        clearInterval(intervalId);
      }, 5000);
    }

    return () => clearInterval(intervalId);
  }, [isRendering, participantes, interval]);

  useEffect(() => {
    if (isWinner) {
     setGanadorSeleccionado(empleado);
    }
  }, [isWinner]);

  useEffect(() => {
    window.addEventListener('keypress', e => {
      if(!isRendering){
        setIsRendering(true);
      }
    })
  }, [])

  return (
    <div>
      
      {
        Object.keys(ganadorSeleccionado).length === 0 && !isRendering ?
        <>
         
        </>
        :
        <div>
          <h1 style={{textShadow: '2px 2px 4px #2E419E', fontFamily: 'Libre Baskerville, serif, helvetica', marginTop: '-60px', color: '#000000'}}>{empleado.participante} ({empleado.cedula})</h1>
          
          <Divider sx={{color: '#2E419E', borderBottomWidth: '2px'}} />
        </div>
      }

      <Confetti
        style={isWinner ? { display: 'block' } : { display: 'none' }}
        width={width}
        height={height}
      />
      
      <button id='btn-sorteo' disabled={isRendering | participantes.length < 2} type='submit' style={{textTransform: 'uppercase', marginTop: '1.5pc', height: '55px', width: '35%', fontSize: '25px', backgroundColor: '#2E419E', color: 'white'}} className="btn btn-lg rounded-pill" onClick={() => {setIsRendering(!isRendering); setImageValidate(true); }}>
        Iniciar Sorteo
      </button>

    </div>
  );
};

export const SorteoCDEEE = () => {

  // ? HOOK-STATE GANADOR
  const [ganadorSeleccionado, setGanadorSeleccionado] = useState({});

  const [imageValidate, setImageValidate] = useState(false);

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const participantes = useSelector(selectListParticipantesCDEEE);
  const updateList = useSelector(selectUpdateList);

  // * FUNCION PARA REFRESCAR LISTA
  const refreshList = () => dispatch(fetchGetParticipantesCDEEE());

  useEffect(() => {
    refreshList();
  }, [])

  useEffect(() => {
    if(Object.keys(ganadorSeleccionado).length > 0){
      dispatch(fetchSaveGanadorParticipante(ganadorSeleccionado.cedula))
    }
  }, [ganadorSeleccionado])
  
  useEffect(() => {

    if(updateList){
      refreshList();
      dispatch(fetchUpdateList());
    }
    
  }, [updateList])
  

  return (
    <Encabezado title='Sorteo' ano={new Date().getFullYear()}>
       <div className="d-flex justify-content-center">
        
        <div className="text-center">
          <Box component='div'>
            <Paper 
            sx={{
              backgroundImage: `url(${fondoImagenInicial})`,
              backgroundSize: 'cover', // Asegura que la imagen cubra todo el componente
              backgroundPosition: 'center', // Centra la imagen
              minHeight: '60pc',
              display: 'flex', // Flexbox para centrar el contenido
              justifyContent: 'center', // Centrado horizontal
              alignItems: 'center', // Centrado vertical
              color: 'white', // Color del texto
            }}
            
            elevation={5} variant='outlined'>

              <Box padding={10} height={450} width={1000}>
                
                <Stack mt={10}>
                  <NamePicker 
                  participantes={participantes} 
                  interval={INTERVAL} 
                  setGanadorSeleccionado={setGanadorSeleccionado} 
                  ganadorSeleccionado={ganadorSeleccionado}
                  setImageValidate={setImageValidate}
                  imageValidate={imageValidate}
                  />
                </Stack>
              </Box>

            </Paper>
          </Box>
        </div>
            
      </div>
    </Encabezado>
  );
};